import { Menu, MenuItem } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, {useCallback, useEffect, useState} from "react";
import {IInsertOption, insertOptions} from "./insertOptions";

const useStyles = makeStyles(theme => ({
    option: {
        textTransform: "capitalize"
    }
}));

interface IProps {
    position?: {top: number, left: number}
    onClose: () => void
    onInsert: (option: IInsertOption) => void
}
export default function InsertMenu({onClose, onInsert, position}: IProps) {
    const classes = useStyles();
    const [selected, setSelected] = useState(0);
    const insertOption = useCallback((option: IInsertOption) => {
        onInsert(option);
        onClose();
    }, [onClose, onInsert]);
    const handleClick = ({currentTarget}: React.MouseEvent<HTMLElement>) => {
        const selected = insertOptions.findIndex(option => option.option === currentTarget.dataset.insert);

        if (selected !== -1) {
            insertOption(insertOptions[selected]);
        }
    };

    useEffect(() => {
        const handleKeydown = (event: KeyboardEvent) => {
            if (position === undefined) {
                return;
            } else if (event.code === "ArrowUp") {
                setSelected(selected === 0 ? insertOptions.length - 1 : selected - 1);
            } else if (event.code === "ArrowDown") {
                setSelected((selected + 1) % insertOptions.length);
            } else if (event.code === "Enter") {
                insertOption(insertOptions[selected]);
                event.preventDefault();
            } else {
                const shortcut = insertOptions.findIndex(option => option.shortcut === event.code);
                
                if (shortcut !== -1) {
                    insertOption(insertOptions[shortcut]);
                    event.preventDefault();
                }
            }
        };

        window.addEventListener('keydown', handleKeydown);
        return () => {
            window.removeEventListener('keydown', handleKeydown);
        };
    }, [insertOption, position, selected, setSelected]);
    return (
        <Menu
            anchorPosition={position} anchorReference="anchorPosition" autoFocus={false} keepMounted onClose={onClose}
            open={Boolean(position)}>
            {insertOptions.map((insert, index) => (
                <MenuItem
                    className={classes.option} data-insert={insert.option} key={insert.option} onClick={handleClick}
                    selected={selected === index}>
                    {insert.display}
                </MenuItem>
            ))}
        </Menu>
    );
}